export enum AgencyGroupType {
  Sales = 'Sales',
  Rentals = 'Rentals'
}
